module.exports = __webpack_public_path__ + "img/sleeve back armhole length.850c4c30.png";